const textFragilityColor = (statusId, classes) => {
  switch (statusId) {
    case 1:
      return classes.textLowFragility
    case 2:
      return classes.textMediumFragility
    case 3:
      return classes.textHighFragility
    case 4:
      return classes.textSevereFragility
    default:
      return ''
  }
}

export default textFragilityColor
